import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from  '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/Global-Services/common.service';
import { HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import * as FileSaver from 'file-saver';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalVariable } from 'src/app/Variable/global-variable';

export interface DialogData {
  FTERecord: any;
  CurrUserGPN: string;
}

@Component({
  selector: "app-pop-up-attach-revised-letter",
  standalone: false,
  templateUrl: "./pop-up-attach-revised-letter.component.html",
  styleUrl: "./pop-up-attach-revised-letter.component.css",
})
export class PopUpAttachRevisedLetterComponent implements OnInit {
  ErrorMessage =  [];
  isLoading: Boolean = false;
  RevisedLetterList = {
    RevisedLetterAttachmentName: "",
    RevisedLetterAttachmentID: 0,
    ID: 0,
    CurrentUserGPN: '',
    Type: '',
    FTEID: '',
  };
  @ViewChild("fileInput") fileInput!: ElementRef;

  formData: any;
  constructor(
    public dialogRef: MatDialogRef<PopUpAttachRevisedLetterComponent>,
    private _router: Router,
    private gservice: CommonService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _data: DialogData,
    private status: HTTPStatus,
    public gService: CommonService,
    private gVariable: GlobalVariable,
  ) {}

  ngOnInit() {
    this.RevisedLetterList.ID = this._data.FTERecord.ID;
    this.RevisedLetterList.FTEID = this._data.FTERecord.FTEID;
    this.RevisedLetterList.CurrentUserGPN = this.gVariable.User.UserGPN;
    this.RevisedLetterList.Type = "LetterGenerated";
    console.log(this.RevisedLetterList.RevisedLetterAttachmentName);
  }

  AttachRevisedLetter(event) {
    this.isLoading = true;
    let type = "LetterGenerated";
    if (event.target.files.length > 0) {
      const fileList: FileList = event.target.files;
      const file: File = fileList[0];
      const maxLength = 1024 * 1024 * 5;
      const fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1);

      if (fileExtension.toLowerCase() === 'pdf') {
      this.formData = new FormData();
      if (event.target.files[0].size > maxLength) {
        alert("Filesize can not be more than 5 mb.");
        this.RevisedLetterList.RevisedLetterAttachmentName = "";
        this.RevisedLetterList.RevisedLetterAttachmentID = 0;
        this.clearFileInput();
        this.isLoading = false;
        return;
      }
      this.formData.append("Attachments", file, file.name);

      this.gService
        .UploadAttachment(
          this.formData,
          "FTEDetails/UploadRevisedLetterAttachment"
        )
        .subscribe((data) => {
          if(data == "Success")
          {
            this.isLoading = false;
          this.RevisedLetterList.RevisedLetterAttachmentName = file.name;
          }
          else
          {
            this.isLoading = false;
            alert(data);
            this.RevisedLetterList.RevisedLetterAttachmentName = "";
            this.RevisedLetterList.RevisedLetterAttachmentID = 0;
            this.clearFileInput();
          }
        });
      } else {
        this.isLoading = false;
        alert('Please upload pdf file.');
        this.formData = null;
          this.RevisedLetterList.RevisedLetterAttachmentName = '';
          this.RevisedLetterList.RevisedLetterAttachmentID = 0;
          this.clearFileInput();
      }
    }
  }

  GetAttachmentbyAttachmentID(id: any, type: any) {
    this.isLoading = true;
    if (id == 0) {
      this.gService
        .Download(
          "FTEDetails/GetAttachmentbyAttachmentName?AttachmentName=" +
            this.RevisedLetterList.RevisedLetterAttachmentName
        )
        .subscribe((data: any) => {
          const blob = new Blob([data], { type: "application/octet-stream" });
          FileSaver.saveAs(
            blob,
            this.RevisedLetterList.RevisedLetterAttachmentName
          );
        });
        this.isLoading = false;
    }
  }

  UploadRevisedLetter() {

    this.ErrorMessage = [];

    this.isLoading = true;
    if(this.RevisedLetterList.RevisedLetterAttachmentName == null || this.RevisedLetterList.RevisedLetterAttachmentName == "")
    {
      this.ErrorMessage.push({ message: 'Please attach revised letter.' });
    }

    if (this.ErrorMessage.length > 0) {
      this.isLoading = false;
      return;
    }

     var boolReturn = false;
    boolReturn = confirm('Are you sure you want to attach this letter?');
    if (boolReturn === false) {
      this.isLoading = false;
      return;
    }

    this.gService.PostService(this.RevisedLetterList, 'FTEDetails/UploadRevisedLetter').subscribe(data => {
      if(data != null && data != "" && data.toLowerCase() != "success")
      {
        alert(data);
        this.isLoading = false;
        return;
      }
      this.isLoading = false;
      alert("Revised Letter attached Successfully!");
      this.closeDialog();
    },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.gService.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
        });
        this.gService.RedirectToErrorPage(2);
      });
  }

  DeleteRevisedLetter() {
    this.isLoading = true;
    let boolReturnConfirm = false;
    boolReturnConfirm = confirm("Are you sure you want to delete");
    if (boolReturnConfirm === false) {
      this.isLoading = false;
      return;
    }

    if (this.RevisedLetterList.RevisedLetterAttachmentName != null && this.RevisedLetterList.RevisedLetterAttachmentName != "") {
      this.gService
        .PostService(
          { FileName: this.RevisedLetterList.RevisedLetterAttachmentName },
          "FTEDetails/DeleteUploadedFile"
        )
        .subscribe(
          (data) => {
            if (data === "Success") {
              this.isLoading = false;
              this.RevisedLetterList.RevisedLetterAttachmentName = "";
              this.RevisedLetterList.RevisedLetterAttachmentID = 0;
              this.clearFileInput();
            }
          },
          (err: HttpErrorResponse) => {
            this.isLoading = false;
            this.gService
              .GetRestItems("Master/LogError?httpException=" + err)
              .subscribe((data) => {});
            this._router.navigate(["/error/2"]);
          }
        );
    } else {
      this.isLoading = false;
      this.RevisedLetterList.RevisedLetterAttachmentName = "";
      this.RevisedLetterList.RevisedLetterAttachmentID = 0;
      this.clearFileInput();
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  clearFileInput() {
    this.fileInput.nativeElement.value = "";
  }
}
